export default {"src":"/_next/static/media/clerk.f36c831b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};